var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-context-menu',{ref:"actionsContextMenu",attrs:{"options":_vm.options,"element-id":"actionsContextMenu"},on:{"option-clicked":_vm.optionClicked}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff14309","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/invoice/actions-menu/actions-context-menu.vue
// module id = RrNZ
// module chunks = 23